var $ab45056fafb7a102$exports = {};
$ab45056fafb7a102$exports = {
    "endTime": `Heure de fin`,
    "startTime": `Heure de d\xe9but`,
    "time": `Heure`
};


export {$ab45056fafb7a102$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
